module.exports = __webpack_public_path__ + "static/media/effect_button_play.529ee7cd.mp3";